import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient global. Alinhado ao mobile (`grana-money-app/src/shared/api/query-client.ts`):
 *  - `networkMode: 'offlineFirst'` — app financeiro precisa servir cache stale offline.
 *  - `staleTime: 5min` — reduz refetch redundante em uso normal.
 *  - `gcTime: 24h` — cache sobrevive a reload da aba dentro de uma jornada de uso diario.
 *  - `refetchOnWindowFocus: true` — diferente do mobile (RN nao tem "window focus");
 *    no web e util invalidar quando usuario volta de outra aba apos periodo longo.
 *
 * Extraido em modulo proprio (em vez de inline no `_layout.tsx`) para permitir
 * `queryClient.clear()` no logout sem precisar consumir o hook do contexto.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: true,
      networkMode: 'offlineFirst',
    },
    mutations: {
      retry: 0,
      networkMode: 'offlineFirst',
    },
  },
});
